import { atom, useAtom } from "jotai";
import { useCallback } from "react";
import { AdminItemDto } from "@rinastyling/common";
import { AdminService } from "../services/AdminService";
import { handleFetchError } from "../utils/clientErrorHandeling";

export const adminItemAtom = atom<AdminItemDto[]>([]);
const useAdminItems = () => {
  const [items, setItems] = useAtom(adminItemAtom);
  const getItems = useCallback(async () => {
    try {
      const res = await new AdminService().getItems();
      setItems(res.items);
      console.log("items has been retrieved", res.items);
    } catch (error) {
      handleFetchError(error);
    }
  }, [setItems]);

  const handleAddItem = useCallback(
    async (body: Parameters<AdminService["addItem"]>[0]) => {
      try {
        const res = await new AdminService().addItem(body);
        setTimeout(() => {
          getItems();
        }, 1000);
        return res;
      } catch (error) {
        handleFetchError(error);
        return null;
      }
    },
    [getItems]
  );
  const handleEditItem = useCallback(
    async (body: Parameters<AdminService["editItem"]>[0]) => {
      try {
        const res = await new AdminService().editItem(body);
        getItems();
        return res;
      } catch (error) {
        handleFetchError(error);
        return null;
      }
    },
    [getItems]
  );
  const handleDeleteItem = useCallback(
    async (params: Parameters<AdminService["deleteItem"]>[0]) => {
      try {
        const res = await new AdminService().deleteItem(params);
        getItems();
        return res;
      } catch (error) {
        handleFetchError(error);
        return null;
      }
    },
    [getItems]
  );

  const handleDeleteImg = useCallback(
    async ({
      imgFileName,
      itemId
    }: {
      imgFileName: string;
      itemId: string;
    }) => {
      try {
        const res = await new AdminService().deleteImgFromItem({
          imgFileName: imgFileName,
          itemId
        });
        console.log(res);
        getItems();
        return res;
      } catch (error) {
        handleFetchError(error);
      }
    },
    [getItems]
  );
  return {
    handleAddItem,
    getItems,
    items,
    handleDeleteImg,
    handleEditItem,
    handleDeleteItem
  };
};

export default useAdminItems;
